import {Form} from "@/utils/Form";
import {UpdateIvrMutation, UpdateIvrMutationVariables, useUpdateIvrMutation} from "../queries.generated";
import deepEqual from "deep-equal";

class IvrSettingsForm extends Form<UpdateIvrMutation, UpdateIvrMutationVariables> {
    constructor(initialData: UpdateIvrMutationVariables) {
        super("updateIvr");
        this.hooks(useUpdateIvrMutation, initialData);
    }

    protected override get filteredVariables(): UpdateIvrMutationVariables {
        const copy = structuredClone(this.values);

        for (const key of Object.keys(copy) as (keyof UpdateIvrMutationVariables)[]) {
            if (key !== "id" && deepEqual(copy[key], this.initialData[key])) {
                delete copy[key];
            }
        }

        return copy;
    }
}

export default IvrSettingsForm;
